import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="empty-state-container">
      <div class="empty-icon">
        <i [class]="iconClass"></i>
      </div>
      <h3 class="empty-title">{{ title }}</h3>
      <p class="empty-message">{{ message }}</p>
      <button *ngIf="actionText" 
              class="ih-btn-primary" 
              (click)="onAction()">
        {{ actionText }}
      </button>
    </div>
  `,
  styles: [`
    .empty-state-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 48px 24px;
      text-align: center;
    }

    .empty-icon {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background: linear-gradient(135deg, #E50000 0%, #FF6B6B 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 24px;
      opacity: 0.1;
    }

    .empty-icon i {
      font-size: 40px;
      color: #E50000;
    }

    .empty-title {
      font-size: 18px;
      font-weight: 600;
      color: #333;
      margin: 0 0 8px 0;
    }

    .empty-message {
      font-size: 14px;
      color: #666;
      margin: 0 0 24px 0;
      max-width: 300px;
    }

    .ih-btn-primary {
      padding: 10px 24px;
      font-size: 14px;
      border: none;
      border-radius: 8px;
      background: linear-gradient(135deg, #E50000 0%, #FF6B6B 100%);
      color: white;
      font-weight: 500;
      cursor: pointer;
      transition: transform 0.2s;
    }

    .ih-btn-primary:hover {
      transform: translateY(-2px);
    }
  `]
})
export class EmptyStateComponent {
  @Input() icon: string = 'fa-solid fa-inbox';
  @Input() title: string = 'No Data';
  @Input() message: string = 'There is no data to display';
  @Input() actionText?: string;
  @Output() action = new EventEmitter<void>();

  get iconClass(): string {
    return this.icon;
  }

  onAction(): void {
    this.action.emit();
  }
}
